module.exports = __webpack_public_path__ + "static/media/deposit.c2f29652.svg";